import * as React from "react";
import { FooterNote } from "../../Common/Components/FormComponents";
import { SearchInputContainer } from "../../../components/pages/Analytics/UsersTablePage/UsersPage.styles";
import { StyledFieldset, TitleLegend } from "../../Common/Components/EditableTitle";
import { Input } from "../../Common/Components/EditableTitle";
import { Select } from "../../../components/pages/Analytics/UnitsAnalytics/LocaleFilter/LocaleFilterSelection.styles";
import { ErrorHeader } from "../../Common/Components/FormComponents";
import { ValidFieldIcon, InvalidFieldIcon } from "../../../components/utils/Icons/AccountsIcons";
import styled from "styled-components";
import { CloseHelpTextButton } from "../../../components/pages/Analytics/common/MoreButton";

interface IAccountInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  edit: boolean;
  legend: string;
  name: string;
  displayVerification: boolean;
  errorMessage: string | null;
  closeOpenText: () => void;
  onClickInput: () => void;
}

interface IAccountSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  legend: string;
  name: string;
  footerNote: string | undefined;
}

const AccountFormsFieldSet = styled(StyledFieldset)`
  display: flex;
  flex-direction: row;
  alig-items: baseline;
  justify-content: space-between;
`;

const AccountsLegend = styled(TitleLegend)<{ edit: boolean }>`
  padding: 0 1rem;
  color: ${({ theme, edit }) => (edit ? theme.colors.menuBlueLight : theme.colors.grey)};
`;

const AccountsInputContainer = styled(SearchInputContainer)`
  padding-right: 1rem;
  margin-right: 0;
`;

const AccountsInput = styled(Input)`
  height: 4rem;
  padding: 0 1rem;
  background-color: ${({ theme }) => theme.colors.lightgrey3};
`;

const AccountsFieldMessage = styled(ErrorHeader)<{ isError: boolean }>`
  color: ${props => (props.isError ? "red" : "black")}
  margin: 0 0.2rem;
`;

const MessageContainer = styled.div`
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem 0rem;
`;

export const AccountFormsField: React.FC<IAccountInputProps> = ({
  legend,
  name,
  displayVerification,
  errorMessage,
  edit,
  onClickInput,
  closeOpenText,
  ...inputProps
}) => (
  <>
    <AccountFormsFieldSet isMainTitle={false} edit={true}>
      <AccountsLegend edit={edit}>{legend}</AccountsLegend>
      <AccountsInputContainer style={{ flexGrow: 1 }}>
        <AccountsInput id={name} name={name} {...inputProps} onClick={onClickInput} />
        {displayVerification && (
          <div data-testid="validation-check">
            <ValidFieldIcon />
          </div>
        )}
        {errorMessage && !displayVerification && (
          <div data-testid="invalid-field-icon">
            <InvalidFieldIcon />
          </div>
        )}
      </AccountsInputContainer>
    </AccountFormsFieldSet>
    {errorMessage && (
      <MessageContainer>
        {displayVerification && (
          <CloseHelpTextButton onClick={closeOpenText} isOpenText={errorMessage ? true : false} />
        )}
        <AccountsFieldMessage isError={!displayVerification}>{errorMessage}</AccountsFieldMessage>
      </MessageContainer>
    )}
    <br />
  </>
);

export const AccountFormSelect: React.FC<IAccountSelectProps> = ({
  legend,
  name,
  footerNote,
  children,
  ...selectProps
}) => (
  <>
    <div>
      <legend style={{ fontWeight: "bolder", margin: "0.5rem 0" }}>{legend}</legend>
      <Select name={name} {...selectProps}>
        {children}
      </Select>
    </div>
    {footerNote && <FooterNote>{footerNote}</FooterNote>}
  </>
);
